import { UiCrossIcon } from "@jti/brand-icons/ui-cross";

import { IconButton } from "../IconButton";

import styles from "./Tag.module.scss";

export type TagProps = {
  label?: string;
  description?: string;
  isTruncated?: boolean;
  onDismiss?: () => void;
  dismissAriaLabel?: string;
};

export const Tag = ({ label, description, isTruncated = true, onDismiss, dismissAriaLabel = "Dismiss" }: TagProps) => {
  return (
    <div className={styles.tag}>
      <div className={styles.labelWrapper}>
        {label && (
          <span
            className={isTruncated ? styles.labelTruncated : styles.label}
            aria-label={description ? `${label} ${description}` : label}
          >
            {label}
          </span>
        )}
        {description && (
          <span className={styles.description} aria-hidden="true">
            {description}
          </span>
        )}
      </div>
      <IconButton icon={UiCrossIcon} compact onClick={onDismiss} aria-label={dismissAriaLabel} type="button" />
    </div>
  );
};
